import { Link } from 'react-router-dom';

const advantages = [
  {
    title: 'We offer a wide variety of insurance solutions.',
    bg: 'bg-[#3072b7]',
    textColor: 'text-white',
    iconColor: 'text-white',
  },
  {
    title: 'We are there for you in your time of need.',
    bg: 'bg-white border-2 border-[#9cbde5]',
    textColor: 'text-[#0b2240]',
    iconColor: 'text-[#9cbde5]',
  },
  {
    title: 'We are by your side every step of the way.',
    bg: 'bg-[#0b2240]',
    textColor: 'text-white',
    iconColor: 'text-white',
  },
  {
    title: 'We are licensed insurance advisors.',
    bg: 'bg-white border-2 border-[#9cbde5]',
    textColor: 'text-[#0b2240]',
    iconColor: 'text-[#9cbde5]',
  },
];

export default function AgencyAdvantage() {
  return (
    <section className="py-20 bg-[#f8f9fc]">
      <div className="max-w-screen-xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-6 mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0b2240] mb-2">
              The Independent Agency Advantage
            </h2>
            <p className="text-gray-500">What makes our independent insurance agency different?</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <Link
              to="/about#independent"
              className="bg-[#3072b7] hover:bg-[#0b2240] text-white text-sm font-bold px-5 py-3 rounded-md transition-colors whitespace-nowrap"
            >
              Why Go Independent?
            </Link>
            <Link
              to="/about#companies"
              className="text-[#3072b7] hover:text-[#0b2240] text-sm font-bold py-3 underline underline-offset-4 transition-colors whitespace-nowrap"
            >
              Explore Our Carriers
            </Link>
          </div>
        </div>

        {/* Advantage Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {advantages.map((adv) => (
            <div
              key={adv.title}
              className={`${adv.bg} rounded-lg p-8 flex flex-col items-center text-center gap-4 shadow-sm`}
            >
              <div className={`w-12 h-12 flex items-center justify-center ${adv.iconColor}`}>
                <i className="ri-check-double-line text-3xl" />
              </div>
              <p className={`${adv.textColor} font-semibold text-base leading-snug`}>{adv.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
